import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import IHR from '../../../Assets/Images/Training/Training Compendium/Resilient_and_Responsive_Urbanization.jpg';

const Case_Specific_to_India_Himalayan_Region = () => {

    return (
        <div className="mt-5">
            <h4>Resilient and Responsive Urbanization in the Hill Town – Case Specific to India Himalayan Region (IHR)</h4>

            <div className="card mt-5">
                <img
                    src={IHR}
                    className="card-img-top"
                    alt="Poster"
                />
            </div>

            <div className="mt-5">
                <p><strong>Aim:</strong> To equip participants with knowledge, strategies, and tools for resilient and  sustainable urbanization in hill towns. </p>
                <p>This compendium addresses the severe challenges of unplanned urbanization in  fragile hilly towns, where development degrades environments, depletes water  resources, and amplifies disaster risk. Evidence from these regions is alarming,  showing drying springs, reduced streamflow, and millions of tonnes of  mismanaged waste, directly linking haphazard growth to catastrophic events like  landslides and floods, as validated by the IPCC.</p>
                <p>The document analyzes these complex issues, from resource depletion and  biodiversity loss to emerging challenges like Urban Heat Island (UHI) effects and  tourism-induced stress. It aims to sensitize stakeholders by outlining clear,  actionable pathways to resilience. Key strategies explored include implementing  Nature-based Solutions (NbS), embedding risk mitigation directly into urban  planning and policy, and strengthening institutional accountability to manage  development effectively.As a vital resource for policymakers, urban planners,  disaster management authorities, and local communities, this compendium  provides an integrated framework for action. It champions a future where hilly  towns can achieve sustainable growth while preserving their invaluable ecological  and cultural integrity for generations to come.</p>
            </div>
        </div>
    );
};

export default Case_Specific_to_India_Himalayan_Region;
